import React, { } from "react";
import {
    Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Input, Search, Confirm
} from 'semantic-ui-react';
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../config/appConstants';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import "./materialList.css";
import NoResultFound from "../sharedComponent/noResultFound";

const MaterialListComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (

        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <span className="iconify myiconstyle_1" data-icon="mdi:ellipse-outline" data-inline="false" ></span>
                    <span>Material List</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                                Material List
                            <Search className="theader" onSearchChange={props.onMaterialListSearch}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.materialList.materialListDataList && props.materialList.materialListDataList.length > 0 ? props.materialList.materialListDataList.map(({ displayText, id }) => (
                        <Table.Row style={{verticalAlign: 'baseline'}}>
                            <Table.Cell textAlign="center" className="tableCell">
                                <div className="forcastIcon">
                                    <Icon className="myiconstyle" edit name='trash alternate outline'
                                        onClick={() => { props.onDeleteMaterialList({ materialListId: id }); }}
                                    />
                                    <Icon className="myiconstyle" edit name='edit pencil'
                                        onClick={() => {
                                            props.onOpenModel({ materialListId: id });
                                        }}
                                    />
                                </div>
                            </Table.Cell>
                            <Table.Cell>{displayText}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='2'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.materialList.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
                size='tiny'
            >
                <Modal.Header>{(props.materialList.selectedValue && props.materialList.selectedValue.materialListId > 0) ? "Edit Material List" : "Add Material List"}</Modal.Header>
                <Modal.Content style={{ overflow: 'visible' }}>
                    <Form>
                        <Form.Field required>
                            <label>Material List:</label>
                            <Input
                                placeholder='Enter Material'
                                maxLength={50}
                                value={props.materialList.selectedValue ? props.materialList.selectedValue.materialListName : ""}
                                onChange={(e) => props.handleMaterialListChange(e, { name: "materialList", value: e.target.value })}
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.materialList.isEditMaterialList ?
                        <Button disabled={props.materialList.isSaveButtonDisabled} type="submit" primary onClick={() => props.onSaveMaterialList(props.materialList.selectedValue.materialListId)}> Update </Button> :
                        <Button disabled={props.materialList.isSaveButtonDisabled} type="submit" primary onClick={() => props.onSaveMaterialList()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()} > Back </Button>
                </Modal.Actions>
            </Modal>
            <Confirm
                closeIcon
                open={props.materialList.isShowDeleteConfiram}
                content="Are you sure? Do you want to delete this Material List?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelDelete(); }}
                onConfirm={() => { props.onConfirmDelete(); }}
            />
            {props.materialList.materialListDataList && props.materialList.materialListDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.materialList.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.materialList.pagination.totalCount} />
            }
        </Layout >
    );
}

export default MaterialListComponent;

MaterialListComponent.displayName = "MaterialListComponent";